module.exports = __webpack_public_path__ + "static/media/download.539076c9.svg";